/* SUNVOLT – hanteringsavgift: robust kundvagns-enforcement (utan Plus/Functions).
   Config kommer från snippeten sunvolt-fee-config ([data-sv-fee-config], styrs av
   Temainställningar → Sunvolt – Hanteringsavgift).
   - Avstämning: avgiftens antal hålls = (antal produkter i tillämpningsområdet UTAN installation).
     Läggs till/justeras/tas bort automatiskt vid varje korgändring → går inte att "bara ta bort".
   - Låser avgiftsraden i kundvagnen (döljer ta-bort + antal, lägger not).
   - Re-körs efter varje korguppdatering (cartUpdate / MutationObserver), som resten av temat.
   Notera: 100 % server-tvingande kräver Shopify Functions (app). Detta stoppar all vanlig
   kund-interaktion (UI + auto-återläggning) men en tekniskt kunnig kan kringgå via API. */
(function () {
  var el = document.querySelector('[data-sv-fee-config]');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  if (!cfg || !cfg.enabled || !cfg.feeVariantId || !cfg.feeProductId) return;

  var scopeTypes = String(cfg.scopeTypesRaw || 'Laddboxar')
    .split('\n').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);

  var busy = false;

  function isFee(i) { return i.product_id === cfg.feeProductId; }
  function isInstall(i) { return cfg.installProductId && i.product_id === cfg.installProductId; }
  function isScope(i) { return scopeTypes.indexOf(String(i.product_type || '').toLowerCase()) !== -1; }

  function requiredQty(cart) {
    var box = 0, inst = 0;
    cart.items.forEach(function (i) {
      if (isFee(i)) return;
      if (isScope(i)) box += i.quantity;
      else if (isInstall(i)) inst += i.quantity;
    });
    return Math.max(0, box - inst);
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function cartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }
  function sectionIds() {
    var c = cartElement();
    if (c && typeof c.getSectionsToRender === 'function') return c.getSectionsToRender().map(function (s) { return s.id; });
    return ['cart-icon-bubble'];
  }

  function render(data) {
    var c = cartElement();
    if (c && typeof c.renderContents === 'function' && data && data.sections) {
      c.renderContents(data);
      c.classList.remove('is-empty');
    } else if (document.body.classList.contains('template-cart')) {
      window.location.reload();
    }
    setTimeout(lockUI, 60);
  }

  function feeLineOf(cart) {
    var line = null;
    cart.items.forEach(function (i) { if (isFee(i)) line = i; });
    return line;
  }

  function setQty(cart, qty) {
    var line = feeLineOf(cart);
    var body = { sections: sectionIds(), sections_url: window.location.pathname };
    if (line) {
      body.id = String(line.key);
      body.quantity = qty;
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }
    if (qty > 0) {
      body.items = [{ id: cfg.feeVariantId, quantity: qty }];
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }
    return Promise.resolve(null);
  }

  function reconcile() {
    if (busy) return;
    getCart().then(function (cart) {
      var need = requiredQty(cart);
      var line = feeLineOf(cart);
      var have = line ? line.quantity : 0;
      if (have === need) { lockUI(); return; }
      busy = true;
      setQty(cart, need).then(function (data) {
        busy = false;
        if (data) render(data);
        else setTimeout(lockUI, 60);
      }).catch(function () { busy = false; });
    }).catch(function () {});
  }

  /* Lås avgiftsraden i kundvagnen: dölj ta-bort + antalsväljare, lägg not. */
  function lockUI() {
    if (!cfg.feeHandle) return;
    var links = document.querySelectorAll('a[href*="/products/' + cfg.feeHandle + '"]');
    [].forEach.call(links, function (a) {
      var row = a.closest('.cart-item') || a.closest('tr');
      if (!row || row.dataset.svFeeLocked) return;
      row.dataset.svFeeLocked = '1';
      [].forEach.call(row.querySelectorAll('cart-remove-button, .cart-remove-button, quantity-input, .cart-quantity'), function (c) {
        c.style.display = 'none';
      });
      if (cfg.note) {
        var host = row.querySelector('.cart-item__details') || row.querySelector('.cart-item__name') || row;
        if (host && !host.querySelector('.sv-fee-note')) {
          var n = document.createElement('div');
          n.className = 'sv-fee-note';
          n.textContent = cfg.note;
          host.appendChild(n);
        }
      }
    });
  }

  function init() { reconcile(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(reconcile, 60); });
  }

  var drawer = document.querySelector('cart-drawer');
  if (drawer && window.MutationObserver) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(lockUI, 60); })
      .observe(drawer, { childList: true, subtree: true });
  }
})();
